<template>
    <div class="float-left mr-1" v-if="permiteExibirAprovadores">
        <span class="text-primary">
            <i
                class="fa fa-user fa-lg icon-button"
                title="Aprovadores"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal v-model="mostrarModal" @show="preencherForm()">
            <div slot="modal-title">
                Serviço {{ comprometimento.idComprometimento }} - Aprovadores
            </div>
            <h6 class="heading-1">
                <span>APROVADOR</span>
            </h6>
            <span
                >Nome: <strong>{{ aprovadores.nomeAprovador }}</strong></span
            ><br />
            <span
                >Email: <strong>{{ aprovadores.emailAprovador }}</strong></span
            ><br />

            <div v-if="aprovadores.codAprovadorDesignado">
                <h6 class="heading-1">
                    <span>APROVADOR DESIGNADO</span>
                </h6>

                <span
                    >Nome:
                    <strong>{{
                        aprovadores.nomeAprovadorDesignado
                    }}</strong></span
                ><br />
                <span
                    >Email:
                    <strong>{{
                        aprovadores.emailAprovadorDesignado
                    }}</strong></span
                >
            </div>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fechar()"
                    class="mr-2"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { comprometimentoStatus } from './ComprometimentoStatus'

export default {
    components: {},

    props: {
        comprometimento: {
            type: Object,
            default: () => ({})
        },

        dataServico: {
            type: Object,
            default: () => {}
        },

        isPagamento: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            aprovadores: {}
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fechar() {
            this.mostrarModal = false
        },

        preencherForm() {
            this.obterAprovadores()
        },

        obterAprovadores() {
            this.$store.dispatch('addRequest')

            let promisse
            if (this.isPagamento) {
                promisse = this.dataServico.obterComprometimentoAprovadores(
                    this.comprometimento.idComprometimento
                )
            } else {
                if (
                    this.$route.name ===
                    'FornecedoresContratos_RequisicaoDetalhar'
                ) {
                    promisse = this.dataServico.obterComprometimentoAprovadores(
                        this.$route.params.fornecedorId,
                        this.$route.params.codContrato,
                        this.comprometimento.idComprometimento
                    )
                } else {
                    promisse = this.dataServico.obterComprometimentoAprovadores(
                        this.$route.params.codContrato,
                        this.comprometimento.idComprometimento
                    )
                }
            }

            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        this.aprovadores = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter aprovadores!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    computed: {
        permiteExibirAprovadores() {
            return (
                this.comprometimento.status ==
                    comprometimentoStatus.EM_ANALISE ||
                this.comprometimento.status == comprometimentoStatus.APROVADA ||
                this.comprometimento.status == comprometimentoStatus.REPROVADA
            )
        }
    },

    validations: {}
}
</script>
